export enum DEBUG
{ NO= 0
, INFO
, WARNING
, ERROR
, EXCEPTION }


export enum SCREEN
{ LOADING      = 'loading'
, LOGIN        = 'login'
, WORKGROUPS   = 'workgroups'
, USERS        = 'users'
, JOBS         = 'jobs'
, KEY_MASTERING = 'KEY_MASTERING'
, CLIENTS      = 'clients'
, NOT_FOUND    = 'not-found'
}


export enum COLOR
{
  FG = 'rgba(0, 0, 0, 0.85)'
}

export const ENUM_NON_SELECTED = -1 ;
